<div class="field mb-2 w-full" [ngClass]="options.containerClass">
  <label class="mb-2" *ngIf="options.label">
    {{ options.label | translate }}
    <span
      *ngIf="options?.validators?.required"
      [pTooltip]="'BUTTONS.required' | translate"
      tooltipPosition="top"
      class="text-pink-500"
      >*</span
    >
  </label>
  <p-calendar
    class="w-full"
    styleClass="w-full"
    [formControlName]="options.formControlName"
    [minDate]="options.minDate"
    [maxDate]="options.maxDate"
    [placeholder]="options.placeholder"
    [readonlyInput]="options.readonly"
    [inputId]="options.id"
    [dateFormat]="options.dateFormat ?? 'dd.mm.yy'"
    [timeOnly]="options.timeOnly || false"
    dataType="string"
    [showTime]="true"
    [readonlyInput]="options.readonly"
    [disabledDates]="options.disabledDates"
    [disabledDays]="options.disabledDays"
    [firstDayOfWeek]="1"
  ></p-calendar>
</div>
